<template>
  <div class="container">
    <van-notice-bar
      v-show="notice != ''"
      left-icon="volume-o"
      :text="notice"
      mode="closeable"
      wrapable
    />
    <div class="tui-goods-item">
      <img :src="details.url" class="tui-goods-img" />
      <div class="tui-goods-center">
        <div>
          <div class="tui-goods-top">
            <div>
              <p class="tui-goods-name">{{ details.name }}</p>
            </div>
          </div>
          <div class="tui-goods-attr">
            <p>规格：{{ details.all.skuName }}</p>
          </div>
        </div>
        <div class="tui-goods">
          <div class="tui-price-right">{{ details.totalPoint }}积分</div>
          <p class="tui-num-right">x{{ details.amount }}</p>
        </div>
      </div>
    </div>
    <div class="tui-goods-info">
      <div class="tui-goods-name">
        支付方式：<span class="im">{{
          details.all.orderType == 0 ? "积分" : "卡兑换"
        }}</span>
      </div>
      <div class="tui-goods-name" v-show="details.all.orderType == 0">
        订单总额：<span class="im">{{ details.totalPoint }}</span
        >积分
      </div>
    </div>
    <div class="tui-order-info">
      <div class="tui-order-title">订单信息</div>
      <div class="tui-order-content">
        <div class="tui-order-flex">
          <div class="tui-item-title">订单编号:</div>
          <div class="tui-item-content">{{ details.orderNo }}</div>
        </div>
        <!-- <div class="tui-order-flex">
          <div class="tui-item-title">收货人:</div>
          <div class="tui-item-content">
            {{ details.receiverName }}
          </div>
        </div> -->
        <div class="tui-order-flex">
          <div class="tui-item-title">收货信息:</div>
          <div class="tui-item-content">
            {{ details.receiverName }}, {{ details.all.consigneePhone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
            }}<br /><br />{{ details.receiver }}
          </div>
        </div>
        <!-- <div class="tui-order-flex">
          <div class="tui-item-title">商品合计:</div>
          <div class="tui-item-content">{{ details.totalPoint }}积分</div>
        </div>
        <div class="tui-order-flex">
          <div class="tui-item-title">支付金额:</div>
          <div class="tui-item-content">{{ details.totalPoint }}积分</div>
        </div> -->

        <div class="tui-order-flex">
          <div class="tui-item-title">下单时间:</div>
          <div class="tui-item-content">{{ details.orderCreate }}</div>
        </div>
        <div class="tui-order-flex">
          <div class="tui-item-title">发货时间:</div>
          <div class="tui-item-content">{{ details.all.deliveryDate }}</div>
        </div>
        <div class="tui-order-flex">
          <div class="tui-item-title">完成时间:</div>
          <div class="tui-item-content">{{ details.all.doneTime }}</div>
        </div>
        <div class="tui-order-flex">
          <div class="tui-item-title">订单备注:</div>
          <div class="tui-item-content">{{ details.mark }}</div>
        </div>
         
        <div class="tui-order" v-if="showqy">
          <div class="tui-item-title">商品赠礼:</div>
          <div class="qybox">
            <div class="qyimg">
              <img :src="require('@/assets/images/qy.jpg')" width="60" alt="" />
            </div>
            <div class="qycon">
              <div class="b" @click="qyModel=true">智家会员联合生态卡</div>
              <div >
                点击领取免费获得付费会员体验卡资格
              </div>
              <div class="bz">注：仅支持非付费会员体验卡用户限领一次</div>
            </div>
            <div class="qyimg">
                <van-button
                  round
                  color="var(--theme-color-main)"
                  size="small"
                  @click="getCard(details)"
                  class="get-btn"
                  :disabled="btndis"
                  v-if="showbtn"
                  >领取</van-button
                >

                <van-button
                  round
                  color="#eee"
                  size="small"
                  class="get-btn"
                  disabled
                  v-else
                  >已领取</van-button
                >
              </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="button"
      v-if="receivedS(details.orderCreate, details.status, details.all.isMod)"
    >
      <van-button
        round
        color="var(--theme-color-main)"
        size="large"
        @click="toReceived(details)"
        class="del-but"
        >修改收货信息</van-button
      >
      <div class="info">
        <van-icon name="info-o" />仅支持于次日10时前修改收货地址
      </div>
    </div>
     <van-dialog
      v-model="qyModel"
      title="《智家会员生态联合卡声明》"
      @confirm="qyModel = false"
      theme="round-button"
      confirm-button-color="var(--theme-color-main)"
      confirm-button-text="我知道了"
    >
     <div class="tui-qy">
        <span>业务声明：</span> <br />
        积分商城为向智家会员提供更优质的购物体验，特别推出智家PLUS会员生态联合卡，全方位提升和丰富您在智家APP的购物特权。<br />
        <span>权益介绍及使用规则：</span><br />
        活动期间，在积分商城兑换指定商品可同步开通智家PLUS会员生态联合卡，权益包含专享会员折扣、专享购物卡券、尊享清洗优惠、专属客服服务四大权益。
        具体使用规则请下载智家APP并登录，在我的-PLUS会员中查看和使用。 <br />
        <span>有效期及其他：</span><br />
        智家会员生态联合卡自领取之日起1年内有效，请您合理保存、使用用户名和密码，若发现您的账户有违规行为，智家有权关闭您的PLUS会员开通资格、关停您已开通的PLUS会员服务。
        本活动最终解释权归海尔积分商城所有。<br />
        智家会员生态联合卡每个ID限领取一次，已经开通生态联合卡的用户及智家合伙人、智家客户等非普通用户身份不支持领取。
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { getOrderNotice,receiveGivePlus,checkUserGivePlus } from "@/api/api";
export default {
  components: {},
  data() {
    return {
      details: [],
      notice: "",
      btndis:false,
      showqy:false,
      showbtn:true,
      qyModel: false,
    
    };
  },
  methods: {
    async getNotice() {
      let params = {
        orderNo: this.details.orderNo,
        type: "1",
      };
      let res = await getOrderNotice(params);
      if (res.code === "0000") {
        if (res.data != null) {
          this.notice = res.data.context;
        }
      }
    },
    receivedS(orderCreate, status, ismod) {
      if (orderCreate) {
        var date = new Date(orderCreate.replace(/-/g, "/"));
        date.setDate(new Date(orderCreate.replace(/-/g, "/")).getDate() + 1);
        date.setHours(10);
        date.setMinutes(0);
        date.setSeconds(0);

        if (status == 7 || status == 4 || status == 5 || status == 6) {
          if (new Date() < date && ismod == "0") {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      }
    },
    // 查询是否能够领取智家联合卡(
    async checkCard(item) {
      let params = {
        orderNo: this.details.orderNo,
        buyerId: this.$cookies.get("memberId") || sessionStorage.getItem("memberId"),
        parentOrderNo:this.details.all.parentOrderNo,

      };
      let this_ = this
      // 0 不允许领取  1 未领取  2 已领取
      let res = await checkUserGivePlus(params);
      if (res.code === "0000") {
        if (res.data != null) {
          if (res.data != '0') {
            this_.showqy = true
            res.data == '1'?this_.showbtn = true:this_.showbtn = false
          }
        }
      }
    },
    // 领取卡
    async getCard(item) {
      this.btndis = true
      let this_ = this
      let params = {
        orderNo: this.details.orderNo,
        buyerId: this.$cookies.get("memberId") || sessionStorage.getItem("memberId"),
        parentOrderNo:this.details.all.parentOrderNo,

      };
      let res = await receiveGivePlus(params);
      if (res.code == '0000') {
        if (res.data == false) {
          this_.$toast(res.msg);
        }else{
          this_.$toast("领取成功");
          this_.showbtn = false
        }
      }
    },
    // 修改收货信息
    toReceived(item) {
      this.$router.push({
        path: "/orders/editReceived",
        query: {
          id: item.all.id,
          //将内容传递到编辑地址页面
          name: item.all.receiverName, //获取收货人姓名
          phone: item.all.consigneePhone, //获取收货人手机号
          // city: newAddress, //用于显示的省市区
          // address: address, //用于显示的详细地址
          productId: item.all.productId,
          orderNo: item.all.orderNo,
          //将内容传递到编辑地址页面
          city: item.all.receiverArea, //用于显示的省市区
          address: item.all.receiverAddress, //用于显示的详细地址
          region: item.all.receiverCode,
          back:"order"
        },
      });
    },
  },
  mounted() {
    this.details = this.$route.query.details;
    // if (this.details.all.deliveryReason &&this.details.all.deliveryReason !='') {
    //   this.deliveryShow = true
    // }
    this.checkCard(this.details)
    if (this.details.status == 7) {
      this.getNotice();
    }
  },
};
</script>

<style lang="scss" scoped>
.tui-goods-item {
  width: 100%;
  padding: 30px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  background-color: #fff;
  border-bottom: 1px solid #efefef;
}

.tui-goods-img {
  width: 100px;
  height: 100px;
  display: block;
  flex-shrink: 0;
  border-radius: 10px;
}

.tui-goods-center {
  flex: 1;
  padding-left: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.tui-goods {
  display: flex;
  justify-content: space-between;
  padding-top: 20px;
}

.tui-goods-top {
  display: flex;
  justify-content: space-between;
}

.tui-goods-name {
  max-width: 310px;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  font-size: 28px;
  /* line-height: 32px; */
}

.tui-goods-attr {
  font-size: 26px;
  color: #999999;
  padding-top: 10px;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  display: flex;
  justify-content: space-between;
}

.tui-price-right {
  color: #999999;
}

.tui-num-right {
  text-align: right;
  font-size: 24px;
  color: #888888;
}

.tui-color-red {
  color: #e41f19;
  padding-right: 30px;
}

.tui-goods-price {
  display: flex;
  justify-content: space-between;
  font-size: 24px;
  padding: 20px 30px;
}

.tui-size-24 {
  font-size: 24px;
  line-height: 24px;
}

.tui-order-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  background: #fff;
  padding: 10px 30px 20px;
  box-sizing: border-box;
}

.tui-btn-ml {
  margin-left: 20px;
}

.container {
  // background-color: #fff;
  padding-bottom: 150px;
  width: 750px;
}

.tui-order-header {
  height: 88px;
  background-color: $theme-color-blue;
  display: flex;
  justify-content: space-between;
  padding: 0 30px;

  .tui-header-content {
    font-size: 30px;
    color: #ffffff;
    font-weight: 600;
    line-height: 88px;
  }

  .tui-goods-time {
    font-size: 24px;
    color: #fff;
    display: flex;
    align-items: center;

    .block {
      font-size: 24px;
      color: #ffffff;
    }
  }
}

.tui-img-bg {
  width: 100%;
  height: 160px;
}

.border-bottom {
  border-bottom: 1px solid #e8e8e8;
  width: 710px;
  margin-top: 34px;
}

.tui-flex-box1 {
  padding: 0 20px;
  height: 176px;
  margin-bottom: 20px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #eff5ff;
}

.tui-flex-box {
  padding: 0 20px;
  height: 176px;
  margin: 0 20px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  background-color: #ffffff;
}

.tui-icon-img {
  width: 78px;
  height: 78px;
  flex-shrink: 0;
}

.tui-logistics {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 24px 0 20px;
  box-sizing: border-box;
}

.tui-logistics-text {
  font-size: 28px;
  color: #666666;
}

.tui-logistics-time {
  font-size: 24px;
  padding-top: 12px;
  color: #999999;
}

.tui-addr {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 20px;
  box-sizing: border-box;
}

.tui-addr-userinfo {
  font-size: 30px;
  line-height: 30px;
  color: #333333;
}

.tui-addr-text {
  font-size: 24px;
  line-height: 30px;
  padding-top: 16px;
  margin-right: 80px;
  color: #666666;
}

.tui-addr-tel {
  padding-left: 40px;
  font-size: 28px;
  color: #666666;
}

.tui-order-item {
  margin: 20px;
  border-radius: 10px;
  background-color: #ffffff;
}

.tui-goods-title {
  font-size: 28px;
  height: 99px;
  // border-bottom: 1px solid #efefef;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #ffffff;
  color: #666666;
  margin-left: 30px;
}

.tui-color-red {
  color: #e41f19;
  padding-right: 30px;
}

.tui-goods-price {
  width: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  font-size: 24px;
}

.tui-size-24 {
  font-size: 24px;
  line-height: 24px;
}

.tui-price-large {
  font-size: 32px;
  line-height: 30px;
}

.tui-goods-info {
  width: 100%;
  padding: 30px;
  box-sizing: border-box;
  background: #fff;
}

.tui-price-flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.tui-size24 {
  padding-bottom: 24px;
  font-size: 24px;
  line-height: 24px;
  color: #888;
}

.tui-size32 {
  font-size: 32px;
  line-height: 32px;
  font-weight: 500;
}

.tui-pbtm20 {
  padding-bottom: 20px;
}

.tui-flex-shrink {
  flex-shrink: 0;
}

.tui-primary-color {
  color: #eb0909;
}
.tui-order {
  padding-top: 50px;
}
.tui-order-info {
  margin-top: 20px;
  background-color: #ffffff;
}

.tui-order-title {
  position: relative;
  font-size: 32px;
  line-height: 28px;
  padding: 30px 0;
  margin-left: 30px;
  // border-bottom: 1px solid #e8e8e8;
  color: #999999;
}

.tui-order-content {
  width: 100%;
  padding: 30px;
  box-sizing: border-box;
  background: #fff;
  font-size: 24px;
  line-height: 30px;
}

.tui-order-flex {
  display: flex;
  padding-top: 50px;
}

.tui-order-flex:first-child {
  padding-top: 0;
}

.tui-item-title {
  width: 132px;
  font-size: 28px;
  color: #333333;
  flex: 1;
}

.tui-item-content {
  font-size: 28px;
  color: #999999;
  margin-left: 20px;
  flex: 4;
}

.tui-safe-area {
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: space-between;
  height: 148px;
  margin: 20px;
  background: #ffffff;
  border-radius: 14px;
  padding: 0 30px;

  img {
    width: 80px;
    height: 80px;
    border-radius: 50%;
  }
}

.tui-tabbar {
  width: 100%;
  background: #fff;
  position: fixed;
  left: 0;
  bottom: 0;
  font-size: 26px;
  z-index: 999;
  padding: 30px 0;
}

.tui-bottom {
  margin-right: 30px;
}

.margin-vanbottom {
  width: 180px;
  height: 58px;
  border: 2px solid #999999;
  border-radius: 29px;
}
.tui-goods-info {
  display: flex;
  justify-content: space-around;
  .im {
    color: #d90606;
    font-weight: 500;
  }
}
.button {
  margin: 40px 85px 0;
}
.info {
  color: #999;
  text-align: center;
  margin-top: 10px;
}
.qybox{
  padding-top: 20px;
  margin-top: 10px;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  .qyimg{
    width: 18%;
  }
  .qycon{
    width: 60%;
  }
  .b{
    color: var(--theme-color-main);
    font-size: 32px;
    margin: 10px 0 20px 0;
  }
  .bz{
    color: #999;
    font-size: .25rem;
  }
  .get-btn{
    width: 110px;
    height: 50px;
    margin-top: 40px;
  }
}
.tui-qy {
  padding: 30px 50px;
  color: #999999;
  font-size: 0.3rem;
  text-align: left;
  line-height: 0.5rem;
  span {
    font-size: 0.35rem;
    color: #000;
  }
}
</style>
